import {inject} from '@angular/core';
import {CanActivateFn, Router} from '@angular/router';
import {LocalStorageUtil} from '../utils/local-storage-util';

export const AuthGuard: CanActivateFn = (next, state) => {
  const router = inject(Router);

  if (LocalStorageUtil.getStorage()?.at) {
    return true;
  } else {
    import('../utils/local-storage-util').then(m => m.LocalStorageUtil.setStorage(new m.LocalStorage()));
    return router.createUrlTree(['/auth/login'], {
      queryParams: {redirectUrl: state.url},
    });
  }
};
